<div class="card-body" *ngIf="!submitted">
    <h3 class="card-header">{{ 'forgotPassword.text1' | translate }}</h3>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="form-group">
            <label>{{ 'forgotPassword.text2' | translate }}</label>
            <input type="text" formControlName="email" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
            <div  class="alert-danger">
                <!-- *ngIf="f.email.errors" -->
                <div *ngIf="f.email.touched && f.email.errors?.required">{{ 'forgotPassword.text3' | translate }}</div>
                <div *ngIf="f.email.errors?.email">{{ 'forgotPassword.text4' | translate }}</div>
            </div>
        </div>
        <div class="form-group">
            <button [disabled]="loading || form.invalid" class="btn btn-primary">
                <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                {{ 'forgotPassword.text5' | translate }}
            </button>
            <a routerLink="../login" class="btn btn-danger">{{ 'forgotPassword.text6' | translate }}</a>
        </div>
    </form>
</div>
<div class="card-body" *ngIf="submitted">
    <div class="forgot-password-container">
        <div class="forgot-password-container-title">
            <h2 class="card-title">{{ 'forgotPassword.text7' | translate }}</h2>
        </div>
        <div class="forgot-password-container-body">
            <p>{{ 'forgotPassword.text8' | translate }}</p>
        </div>
        <button class="btn btn-primary" (click)="backToLoginPage()">{{ 'forgotPassword.text9' | translate }}</button>
    </div>
</div>
